import { useState, useEffect } from "react"
import { WizardStep } from "../../ui/wizard"
import { NeutralButton } from "../../common/Buttons"
import { Input } from "@chakra-ui/react"
import { Radio, RadioGroup } from "../../ui/radio"
import { colors } from "../../../utilities/colors"
import AuditUnitDetails from "./AuditUnitDetails"
import { conditionReportAnswerOptions } from "../../../constants/conditionReportEnums"

export default function AuditUnitConditionReport({ auditUnit, auditData, setAuditData, nextStep }) {
  const isValidMileage = (mileage) => /^\d+$/.test(String(mileage ?? '').replace(/,/g, ''))

  const [formValues, setFormValues] = useState({
    mileage: auditData.mileage ?? '',
    key: auditData.key ?? '',
    run_and_drive: auditData.run_and_drive ?? '',
  })

  useEffect(() => {
    setFormValues({
      mileage: auditData.mileage ?? '',
      key: auditData.key ?? '',
      run_and_drive: auditData.run_and_drive ?? '',
    })
  }, [auditData])

  const isComplete = isValidMileage(formValues.mileage) && formValues.key !== '' && formValues.run_and_drive !== ''

  const handleNextStep = () => {
    setAuditData({
      ...auditData,
      mileage: String(formValues.mileage).replace(/,/g, ''),
      key: formValues.key,
      run_and_drive: formValues.run_and_drive,
    })
    nextStep()
  }

  return (
    <WizardStep>
      <div className="flex flex-col items-center w-full h-full">
        <div className="flex flex-col items-center justify-between w-full md:w-4/5 h-full pt-6 px-2">
          <AuditUnitDetails auditUnit={auditUnit} />

          <div className="flex flex-col items-center w-full px-2">
            <div className='flex flex-col items-center w-full m-2'>
              <h1 className="text-2xl font-bold mb-1">Mileage</h1>
              <Input
                aria-label="Mileage"
                inputMode="numeric"
                value={formValues.mileage}
                onChange={(e) => setFormValues({ ...formValues, mileage: e.target.value })}
                placeholder="Enter odometer reading"
                borderWidth={2}
                borderColor={colors.grey}
                _focus={{ borderColor: colors.grey300 }}
                bgColor={colors.black}
                rounded="md"
                p={2}
              />
              {formValues.mileage !== '' && !isValidMileage(formValues.mileage) &&
                <p className="text-fpx-red text-sm mt-1">Mileage must be a whole number</p>
              }
            </div>

            <div className='flex flex-col items-center w-full m-2'>
              <h1 className="text-2xl font-bold mb-1">Keys?</h1>
              <RadioGroup
                value={formValues.key}
                onValueChange={(e) => setFormValues({ ...formValues, key: e.value })}
                display="flex"
                flexDirection={{ base: "column", sm: "row" }}
                gap={{ base: 2, sm: 6 }}
              >
                {Object.entries(conditionReportAnswerOptions).map(([value, label]) => (
                  <Radio key={value} value={value}>{label}</Radio>
                ))}
              </RadioGroup>
            </div>

            <div className='flex flex-col items-center w-full m-2'>
              <h1 className="text-2xl font-bold mb-1">Runs and Drives?</h1>
              <RadioGroup
                value={formValues.run_and_drive}
                onValueChange={(e) => setFormValues({ ...formValues, run_and_drive: e.value })}
                display="flex"
                flexDirection={{ base: "column", sm: "row" }}
                gap={{ base: 2, sm: 6 }}
              >
                {Object.entries(conditionReportAnswerOptions).map(([value, label]) => (
                  <Radio key={value} value={value}>{label}</Radio>
                ))}
              </RadioGroup>
            </div>
          </div>

          <NeutralButton
            text="Next"
            onClick={handleNextStep}
            dataTestId="condition-report-next-button"
            disabled={!isComplete}
          />
        </div>
      </div>
    </WizardStep>
  )
}
